const ROLES = {
  ADMIN: 'admin',
  LABOURER: 'labourer',
  PARTNER_ADMIN: 'partner-admin',
  PARTNER_USER: 'partner-user'
};

export default ROLES;
